import { styled } from '@mui/material';
import { GridDate as GridDateBase } from 'components/Grid';

const PREFIX = 'FinancialsDate';

export const classes = {
  dateIcon: `${PREFIX}-dateIcon`,
};

export const StyledGridDateBase = styled(GridDateBase)({
  [`& .${classes.dateIcon}`]: {
    '& > span > svg': {},
  },
});